import { Component, ViewContainerRef } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Customer } from '../../models/customer/customer-model';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { CustomerService } from '../../services/customer/customer.service';
import { Country } from '../../models/country/country-model';
import { State } from '../../models/state/state-model';
import { StateService } from '../../services/state/state.service';
import { CountryService } from '../../services/country/country.service';
import { City } from '../../models/city/city-model';
import { EnumDropDown } from '../../models/shared/enum-dropdown'

@Component({
    selector: 'app-edit-customer',
    templateUrl: './edit-customer.component.html',
    styleUrls: ['./edit-customer.component.scss']
})
/** edit-customer component*/


export class EditCustomerComponent {
  customerModel = new Customer();
  customerID: string; 
  public customerStatuses: EnumDropDown[];
  errorMessage: any;
  isSubmitted = false;
  customerType: string;
  headingName: string;
  public customerTypeId: number;
  isUniqueShopName = true;
  public dateOfBirthElement: any;
  countryList: Country[] = [];
  mainStateList: State[] = [];
  mailingStateList: State[] = [];
  otherStateList: State[] = [];
  mainCityList: City[] = [];
  mailingCityList: City[] = [];
  /** user-edit ctor */
  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly customerService: CustomerService,
    private readonly toastr: ToastsManager,
    private readonly countryService: CountryService,
    private readonly stateService: StateService,
    private readonly router: Router, vcr: ViewContainerRef) {
    this.toastr.setRootViewContainerRef(vcr);
    this.GetCountries();
    this.activatedRoute.params.subscribe((params: Params) => {
      this.customerID = params['id'];
      this.customerType = params['type'];
      //"/customers"
      this.GetCustomer();
      this.GetCustomerStatus();
      
    });
  }

  GetCustomer() {
    this.customerService.getCUstomer(this.customerID).subscribe(
      data => {
        if (data) { 
          this.customerTypeId = data.customerTypeID;
          if (this.customerTypeId == 1) {
            this.headingName = "Vendor";
          }
          else{
            this.headingName = "Customer";
          }
          this.customerModel.mainCountryID = "";
          this.customerModel.mailingCountryID = "";
          this.customerModel.otherCountryID = "";
          this.customerModel.mainStateID = "";
          this.customerModel.mailingStateID = "";
          this.customerModel.otherStateID = "";

          this.customerModel = data;
          if (this.customerModel.mainCountryID) {
            this.GetMainStatesByCountry({
              target: {
                value: this.customerModel.mainCountryID
              }
            });
            if (this.customerModel.mainStateID) {
              this.GetMainCitesByState({
                target: {
                  value: this.customerModel.mainStateID
                }
              });
            }
            else {
              this.customerModel.mainCityId = "";
            }
          }
          else {
            this.customerModel.mainCountryID = "";
          }
         

          if (this.customerModel.otherCountryID) {
            this.GetOtherStatesByCountry({
              target: {
                value: this.customerModel.otherCountryID
              }
            });
          }
          else {
            this.customerModel.otherCountryID = "";
          }

          if (this.customerModel.mailingCountryID) {
            this.GetMailingStatesByCountry({
              target: {
                value: this.customerModel.mailingCountryID
              }
            });
            if (this.customerModel.mailingStateID) {
              this.GetMailingCitesByState({
                target: {
                  value: this.customerModel.mailingStateID
                }
              });
            }
            else {
              this.customerModel.mainCityId = "";
            }
          }
          else {
            this.customerModel.mailingCountryID = "";
          }
          this.customerModel.birthDate = new Date(this.customerModel.birthDate);



          if (this.customerModel.mainCountryID == null || this.customerModel.mainCountryID == "0")
            this.customerModel.mainCountryID = "";
          if (this.customerModel.mailingCountryID == null || this.customerModel.mailingCountryID == "0")
            this.customerModel.mailingCountryID = "";
          if (this.customerModel.otherCountryID == null || this.customerModel.otherCountryID == "0")
            this.customerModel.otherCountryID = "";
          if (this.customerModel.mainStateID == null || this.customerModel.mainStateID == "0")
            this.customerModel.mainStateID = "";
          if (this.customerModel.mailingStateID == null || this.customerModel.mailingStateID == "0")
            this.customerModel.mailingStateID = "";
          if (this.customerModel.otherStateID == null || this.customerModel.otherStateID == "0")
            this.customerModel.otherStateID = "";
          
        }
      }
    )
  }

  GetCustomerStatus() {
    this.customerService.GetCustomerStatus().subscribe(
      data => {
        this.customerStatuses = data;
      }
    )
  }
  GetMainStatesByCountry($event) {
    this.stateService.getStateByCountryId($event.target.value).subscribe(
      data => {
        this.mainStateList = data;

        if (this.customerModel.mainStateID == null || this.customerModel.mainStateID == "") {
          this.customerModel.mainStateID = "";
        }
      });
  }

  GetMailingStatesByCountry($event) {
    this.stateService.getStateByCountryId($event.target.value).subscribe(
      data => {
        this.mailingStateList = data;

        if (this.customerModel.mailingStateID == null || this.customerModel.mailingStateID == "") {
          this.customerModel.mailingStateID = "";
        }
      });
  }

  GetOtherStatesByCountry($event) {
    this.stateService.getStateByCountryId($event.target.value).subscribe(
      data => {
        this.otherStateList = data;

        if (this.customerModel.otherStateID == null || this.customerModel.otherStateID == "") {
          this.customerModel.otherStateID = "";
        }
      });
  }

  GetCountries() {
    this.countryService.getCountries().subscribe(
      data => {
        this.countryList = data;
      });
  }


  ngSubmit() {
    //this.dateOfBirthElement = document.getElementById("dateOfBirth") as HTMLElement;
    //this.customerModel.birthDate = this.dateOfBirthElement.value;
    

    this.isSubmitted = true;
    this.customerService.UpdateCustomerData(this.customerID, this.customerModel).subscribe(result => {
      if (result) {
        this.toastr.success(this.headingName+ ' has been updated', 'Success');
        
        if (this.customerTypeId == 1) {
          setTimeout(() => {
            this.router.navigate(["/vendors"]);//, this.customerType
          }, 2000);
        }
        else {
          setTimeout(() => {
            this.router.navigate(["/customers"]);//, this.customerType
          }, 2000);
        }
        
      }
      else {
        this.toastr.error('Error occurred. Please try again', 'Error');
        this.isSubmitted = false;
      }
    });
  }
  GetMainCitesByState($event) {
    var value = $event.target.value;
    if (value == undefined || value == "") value = 0;
    this.stateService.GetCitesByState(value).subscribe(
      data => {
        this.mainCityList = data;
        if (this.customerModel.mainCityId == null || this.customerModel.mainCityId == "0") {
          this.customerModel.mainCityId = "";
        }
      });
  }

  GetMailingCitesByState($event) {
    var value = $event.target.value;
    if (value == undefined || value == "") value = 0;
    this.stateService.GetCitesByState(value).subscribe(
      data => {
        this.mailingCityList = data;
        if (this.customerModel.mailingCityId == null || this.customerModel.mailingCityId == "0") {
          this.customerModel.mailingCityId = "";
        }

      });
  }
  IsUniqueShopName() {
    this.customerService.isUniqueShopName(this.customerModel.shopeName, this.customerModel.customerID).subscribe(
      data => {
        if (data) {
          this.isUniqueShopName = true;
        }
        else {
          this.isUniqueShopName = false;
        }
      });
  }
  KeyPressEvenetShopName() {
    this.isUniqueShopName = true;
  }
  onTextChange(Value: string) { 
    var i = 0, strLength = Value.length;
    for (i; i < strLength; i++) {
      Value = Value.replace(" ", "-");
    }
    this.customerModel.shopeName = Value.toLowerCase();
  }
}



// WEBPACK FOOTER //
// ./src/app/customer-components/edit-customer/edit-customer.component.ts